export class InvoiceModel {
    id?: string
    number: string = ''
    createdAt: Date|string = new Date()
    canceledAt?: string|null = null
    verificationCode: string = ''
    dateIssue: string = ''
    url: string = ''    

    constructor(i?:Partial<InvoiceModel>) {
        Object.assign(this, i)
    }

    hasBeenCanceled():boolean {
        return !!this.canceledAt
    }

    hasVerificationCode():boolean {
        return !!this.verificationCode
    }

    hasUrl():boolean {
        return !!this.url
    }
}
